import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonClose } from '@/components/buttons';
import { IconComponent } from '@/components/IconComponent';
import { Modal } from '@/components/Modal';
import { ModalSelectContainer } from '@/components/ModalSelect';
import { useGetCommonStore } from '@/store/commonStore';
import { CurrenciesAvailableBlock } from './CurrenciesAvailable';
import { CurrenciesEnableBlock } from './CurrenciesEnable';
import { ScEditCurrenciesContent, ScModalEditCurrencies } from './styled';

interface EditCurrenciesProps {
  onClose: () => void;
}

export const EditCurrenciesModal: FC<EditCurrenciesProps> = ({ onClose }) => {
  const { t } = useTranslation('deposits');
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return isMobileDevice ? (
    <ModalSelectContainer
      gap={24}
      icon={<IconComponent name="currencyIcon" size="40px" />}
      innerAlignBottom
      onClose={onClose}
      openOptionsInPortal
      title={t('editCurrency.myCurrencies')}
    >
      <EditCurrenciesContent onClose={onClose} />
    </ModalSelectContainer>
  ) : (
    <Modal isPortal>
      <ScModalEditCurrencies>
        <ButtonClose dark onClick={onClose} right={16} top={16} />
        <div className="top-box">
          <IconComponent
            className="currency-icon"
            name="currencyIcon"
            size="40px"
          />
          {t('editCurrency.myCurrencies')}
        </div>
        <EditCurrenciesContent onClose={onClose} />
      </ScModalEditCurrencies>
    </Modal>
  );
};

const EditCurrenciesContent: FC<EditCurrenciesProps> = ({ onClose }) => {
  const { t } = useTranslation('deposits');
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const backButton = useMemo(
    () => (
      <div className="btn-box">
        <Button
          blackTransparent={!isMobileDevice}
          large
          onClick={onClose}
          type="button"
          whiteTransparent={isMobileDevice}
          wide
        >
          {t('back')}
        </Button>
      </div>
    ),
    [isMobileDevice, onClose, t]
  );

  return (
    <ScEditCurrenciesContent>
      <CurrenciesEnableBlock />
      <CurrenciesAvailableBlock />

      {backButton}
    </ScEditCurrenciesContent>
  );
};
